
import TextField from '@mui/material/TextField';
import Autocomplete from '@mui/material/Autocomplete';
import { useEffect, useState } from 'react';

export default function SelectEmails(proyectoPlanRecibido) {
  const [fixedOptions, setFixedOptions] = useState(JSON.parse(JSON.stringify(proyectoPlanRecibido.emailsAdicionalesNotificacion)));
  const [value, setValue] = useState(proyectoPlanRecibido.emailsAdicionalesNotificacion?JSON.parse(JSON.stringify(proyectoPlanRecibido.emailsAdicionalesNotificacion)):[]);
  const [emails, setEmails] = useState([]);

  const cargarEmails = async () => {
    
    // console.log(`decodificado en forma ${JSON.stringify(decoded)}`)
    //console.log(`proyectoPlanRecibido.emailsAdicionalesNotificacion ${JSON.stringify(proyectoPlanRecibido.emailsAdicionalesNotificacion)}`)
    
    const res = await fetch(`http://${process.env.REACT_APP_HOST}:${process.env.REACT_APP_BACKEND_PORT}/usuarios/emails/${sessionStorage.getItem('idEntidad')}`, {
      method: "GET",
      headers: {
        "Content-Type": "application/json",
        "x-access-token": sessionStorage.getItem('token'),
        "perfil": sessionStorage.getItem('perfil')
      }
    })
    const responsables = await res.json()

    setEmails(responsables)
  }
  useEffect(() => {
    (async () => {
      if (proyectoPlanRecibido.emailsAdicionalesNotificacion) {
        setValue(JSON.parse(JSON.stringify(proyectoPlanRecibido.emailsAdicionalesNotificacion)));
        setFixedOptions(JSON.parse(JSON.stringify(proyectoPlanRecibido.emailsAdicionalesNotificacion)));
      }
      else {
        setValue([])
        setFixedOptions([])
      }

      await cargarEmails()
    })();
    // eslint-disable-next-line
  }, [proyectoPlanRecibido]
  )

  return (
    <Autocomplete
      multiple
      sx={{ width: 300 }}
      id="emailsAdicionales"
      value={value}
      isOptionEqualToValue={(option, value) => option.emailInstitucional === value.emailInstitucional}
      onChange={(event, newValue) => {
        setValue([
          ...newValue.filter((option) => fixedOptions.indexOf(option) === -1),
        ]);
        
        proyectoPlanRecibido.emailsAdicionalesNotificacion = newValue
        //console.log(`dentro de onchange proyectoPlan.emailsAdicionalesNotificacion ${proyectoPlanRecibido.emailsAdicionalesNotificacion}`)

      }}
      options={emails}
      getOptionLabel={(option) => option.emailInstitucional}
      renderInput={(params) => (
        <TextField {...params} label="Emails adicionales para notificaciones"
          focused variant='outlined' />
      )}
    />
  );
}
